
import scheduleTrip from './scheduleTrip';

export default {
    scheduleTrip,
}